import React from 'react';
import { Form, Input, Button, Typography, Select, Row, Col, message, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axiosApi from '../../axiosApi/axiosApi';

const { Title } = Typography;
const { Option } = Select;

const Register = ({ setHasLoggedIn }) => {
  const onFinish = async (values) => {
    debugger
    try {
      await axiosApi.post('/create/vendor', values);
      message.success('Registration successful! Please wait for approval.');
      setHasLoggedIn(true);
    } catch (error) {
      message.error(error?.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <Col xs={24}>
      <div style={{ padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Title level={3} style={{ textAlign: 'center' }}>Store Registration</Title>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="storeName" label="Store Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="storeUrl" label="Store URL" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item name="wooConsumerKey" label="WooCommerce Consumer Key" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="wooConsumerSecret" label="WooCommerce Consumer Secret" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          {/* Webhook List */}
          {/* <Form.List name="webhook" rules={[{ required: true, message: 'At least one webhook is required.' }]}>
            {(fields, { add, remove }) => (
              <>
                <label><b>Webhooks</b></label>
                {fields.map(({ key, name, ...restField }) => (
                  <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                    <Form.Item
                      {...restField}
                      name={name}
                      rules={[{ required: true, message: 'Webhook is required' }]}
                    >
                      <Input placeholder="Enter Webhook URL" />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}
              
              </>
            )}
          </Form.List> */}

          <Form.Item name="role" label="Role" initialValue="vendor">
            <Select disabled>
              <Option value="vendor">Vendor</Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" style={{ marginTop: 20, background: "#1677ff", color: "white" }} htmlType="submit" block>Register</Button>
          </Form.Item>
        </Form>
      </div>
    </Col>
  );
};

export default Register;